module.exports = __webpack_public_path__ + "static/media/U region split.a484c6a0.jpg";